import React from "react";
import Button from "react-bootstrap/Button";


const OptionButton = ({
  formComplete,
  href,
  downloadResource,
  openModalForm,
  image,
  className
}) => {
  return (
    <>
      {formComplete ? (
        <Button
          variant="outline-primary"
          size="sm"
          className={`${className} download-button`}
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            window.dataLayer.push({
              downloadResource: downloadResource,
            });
          }}
        >
          Descargar
        </Button>
      ) : (
        <Button
          variant="outline-primary"
          size="sm"
          className={`${className}`}
          onClick={() => openModalForm(href, downloadResource, image)}
        >
          Descargar
        </Button>
      )}
    </>
  );
};

export default OptionButton;
